/**
 * @public
 */
export var DateTimePatternField;
(function (DateTimePatternField) {
    DateTimePatternField["ERA"] = "G";
    DateTimePatternField["YEAR"] = "y";
    DateTimePatternField["MONTH"] = "M";
    DateTimePatternField["DAY"] = "d";
    DateTimePatternField["DAYPERIOD"] = "a";
    DateTimePatternField["DAYPERIOD_FLEX"] = "B";
    DateTimePatternField["HOUR24"] = "H";
    DateTimePatternField["HOUR12"] = "h";
    DateTimePatternField["MINUTE"] = "m";
    DateTimePatternField["SECOND"] = "s";
})(DateTimePatternField || (DateTimePatternField = {}));
/**
 * @public
 */
export var DayPeriod;
(function (DayPeriod) {
    DayPeriod["NOON"] = "noon";
    DayPeriod["MIDNIGHT"] = "midnight";
    DayPeriod["AM"] = "am";
    DayPeriod["PM"] = "pm";
    DayPeriod["MORNING1"] = "morning1";
    DayPeriod["MORNING2"] = "morning2";
    DayPeriod["AFTERNOON1"] = "afternoon1";
    DayPeriod["AFTERNOON2"] = "afternoon2";
    DayPeriod["EVENING1"] = "evening1";
    DayPeriod["EVENING2"] = "evening2";
    DayPeriod["NIGHT1"] = "night1";
    DayPeriod["NIGHT2"] = "night2";
})(DayPeriod || (DayPeriod = {}));
/**
 * @public
 */
export var EraWidth;
(function (EraWidth) {
    EraWidth["NAMES"] = "names";
    EraWidth["ABBR"] = "abbr";
    EraWidth["NARROW"] = "narrow";
})(EraWidth || (EraWidth = {}));
/**
 * @public
 */
export var FieldWidth;
(function (FieldWidth) {
    FieldWidth["ABBREVIATED"] = "abbreviated";
    FieldWidth["NARROW"] = "narrow";
    FieldWidth["SHORT"] = "short";
    FieldWidth["WIDE"] = "wide";
})(FieldWidth || (FieldWidth = {}));
/**
 * @public
 */
export var FormatWidth;
(function (FormatWidth) {
    FormatWidth["SHORT"] = "short";
    FormatWidth["MEDIUM"] = "medium";
    FormatWidth["LONG"] = "long";
    FormatWidth["FULL"] = "full";
})(FormatWidth || (FormatWidth = {}));
/**
 * @public
 */
export var Quarter;
(function (Quarter) {
    Quarter["FIRST"] = "1";
    Quarter["SECOND"] = "2";
    Quarter["THIRD"] = "3";
    Quarter["FOURTH"] = "4";
})(Quarter || (Quarter = {}));
/**
 * @public
 */
export var Weekday;
(function (Weekday) {
    Weekday["SUNDAY"] = "1";
    Weekday["MONDAY"] = "2";
    Weekday["TUESDAY"] = "3";
    Weekday["WEDNESDAY"] = "4";
    Weekday["THURSDAY"] = "5";
    Weekday["FRIDAY"] = "6";
    Weekday["SATURDAY"] = "7";
})(Weekday || (Weekday = {}));
//# sourceMappingURL=calendars.js.map